module.exports = __webpack_public_path__ + "media/assets/img/screenshots/races-by-year-0ecb77a518050939aca857c990fd0da1.png";